import styled from "styled-components";
import MenuIcon from "../../assests/images/menu-icon.png";
import CloseIcon from "../../assests/images/close-icon.png";
export const Fixheader = styled.div`
  position: relative;
  z-index: 1;
  @media screen and (max-width: 1024px) {
    background: #01606f;
    width: 100%;
    left: 0;
  }
  .navbar-toggler {
    @media screen and (max-width: 1024px) {
      border: none;
      padding: 0;
      position: absolute;
      right: 13px;
      top: 22px;
      display: block;
      z-index: 99999;
      transition: all 0.5s ease-in-out;

      &:focus {
        text-decoration: none;
        outline: 0;
        box-shadow: none;
      }
    }
    @media screen and (max-width: 991px) {
      top: 23px;
    }
    @media screen and (max-width: 767px) {
      top: 15px;
    }
    @media screen and (max-width: 575px) {
      top: 19px;
      right: 10px;
    }
  }

  .bg-color-new {
    background: #01606f;

    &.flex-col {
      flex-direction: column;
      padding: 0;
      z-index: 999;
      @media screen and (max-width: 1024px) {
        position: fixed;
        width: 100%;
        top: 0;
      }
      .navbar-brand {
        padding: 0;
        margin: 0;
        cursor: pointer;
        img {
          @media screen and (max-width: 991px) {
            width: 100%;
            max-width: 200px;
            height: auto;
          }
        }
      }
    }
  }
  .navbar-toggler {
    .navbar-toggler-icon {
      background-image: url(${CloseIcon});
      width: 21px;
      height: 21px;
      @media screen and (max-width: 1024px) {
        margin-top: 0px;
      }
    }
    &.collapsed {
      .navbar-toggler-icon {
        // background-image:url(${MenuIcon});
        width: 30px;
        height: 4px;
        top: 13px;
        background-color: #ddd;
        border-radius: 4px;
        position: absolute;
        transition-property: transform;
        transition-duration: 0.15s;
        transition-timing-function: ease;
        left: -27px;
        &:before,
        &:after {
          background: #ddd;
          position: absolute;
          width: 30px;
          height: 4px;
          content: "";
          bottom: -7px;
          left: 0px;
          border-radius: 20px;
        }
        &:before {
          bottom: -14px;
        }
        @media screen and (max-width: 1024px) {
          margin-top: 0px;
        }
      }
      .navbar-nav {
        @media screen and (max-width: 1024px) {
          flex-direction: row;
          gap: 50px;
          padding: 60px 20px 0;
        }
      }
    }
  }
  .bottom-header-section {
    //   @media screen and (max-width:1024px) {
    //    padding:0;
    //   }
    .navbar-nav {
      @media screen and (max-width: 1024px) {
        flex-direction: column;
        gap: 0px;
        padding: 0 0 15px 15px;
      }
      @media screen and (max-width: 991px) {
        padding: 0px;
      }
    }
  }
`;
export const TopnavBar = styled.div`
  display: flex;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 10px 0px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  @media screen and (max-width: 1024px) {
    border-bottom: none;
  }
`;

export const FixsubHeader = styled.div`
    &.fixed-navbar {
        width: 100%;
        position: relative;
        transition: top 0.3s ease-in-out;
        @media screen and (max-width:1024px) { 
              position: unset;
        }
          .onscroll-show{
            // @media screen and (max-width:1024px) { 
            //   display: flex;
            // }
          }
        &.fixed {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            z-index: 1000;
            background: rgba(1, 96, 111, 0.6);
            //   .onscroll-show{
            //     display: flex;
            //         margin-left: 12px;
            //     @media screen and (max-width:1024px) {
            //         display: flex;
            //     }
               @media screen and (max-width:1024px) {
                   background: #01606F;
                }

            // }
            // .onscroll-hide{
            //     display: none; 
               
            //     @media screen and (max-width:1024px) {
            //        display: flex;
            //     }
                  
            // }
            .search-header {
             @media screen and (max-width:1024px) {
                max-width: 97%;
                margin: 0;
              }
            @media screen and (max-width:767px) {
                            max-width: 260px;
                            margin: 0 auto;
                }
            .login-btn{
             @media screen and (max-width:1440px) { 
                 padding: 8px 8px;

             }
            }
            .user-write-review.mobile-write-btn{
                 @media screen and (max-width:1024px) { 
                    display:block;
                 
                 }
            }
            @media screen and (max-width:1024px) { 
                   position: static;
                
             }
           @media screen and (max-width:1024px) { 
               .bag-img {top:27px;}
}
            .write-yellow-btn{
                white-space: nowrap;
                 
            }
            
             @media screen and (max-width:1024px) { 
                
             
              .user-write-review{
                display:none;
              }
            }
               @media screen and (max-width:767px) { 
                   .bag-img {top:17px;}
                  .bottom-header-section{
                    justify-content:center;
                }
               }
            &:before{
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                backdrop-filter: blur(15px);
                z-index: -1;
            //  @media screen and (max-width:1024px) {
            //       backdrop-filter: unset;
            //       position: unset;
            //       }
            }
             
          
        }
    }
    .write-yellow-btn{
       display:block;
        @media screen and (max-width:1440px) {
           white-space: nowrap;
               padding: 10px 8px;
         }
        
         @media screen and (max-width:767px) {
            padding: 7px 23px;
         }
    }
    .user-write-review.mobile-write-btn {
             display:none;
             @media screen and (max-width:1024px) {
               display:block;
               margin-bottom: 20px;
             }              
   }
.user-btn.mobile-menu-user{
        display:none;
        @media screen and (max-width:1024px) {
            display:block;
            padding-bottom:45px;
        }
    }
    // @media screen and (max-width:1024px) {                 

    //     .mobile-menu-user{
    //         display:block;
    //         .login-btn{
    //             width:100%; 
    //         }  
    //     }    
    // }                   
     .onscroll-hide{
    //    .search-show-in-inner-page{
    //              display: none !important;
    //        @media screen and (max-width:1024px) {
    //         display: none !important;
    //        }      
    //    } 
     }
`;
export const FixdnavBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 0;
  @media screen and (max-width: 991px) {
    justify-content: end;
  }
  @media screen and (max-width: 767px) {
    justify-content: center;
  }
`;

export const InputGroupIcon = styled.div`
  padding-right: 10px;
  .search-group-icon {
    width: 40px;
    min-width: 40px;
    height: 40px;
    background: #f9dc70;
    border-radius: 10px;
    padding: 10px;
    @media screen and (max-width: 767px) {
      width: 30px;
      min-width: 30px;
      height: 30px;
      padding: 7px;
      border-radius: 5px;
    }
  }
`;
